export const INVOICES_KEY = ['invoices'] as const
export const INVOICE_STATS_KEY = ['invoices', 'stats'] as const

export function invoiceDetailKey(id: string) {
  return ['invoices', 'detail', id] as const
}
